import initialState from './ScreensInitialState';
import reducers from './ScreensReducer';

export default {
  initialState,
  reducers,
};
